import { render, staticRenderFns } from "./evolution-track.vue?vue&type=template&id=ed48ae80&scoped=true"
import script from "./evolution-track.vue?vue&type=script&lang=js"
export * from "./evolution-track.vue?vue&type=script&lang=js"
import style0 from "./evolution-track.vue?vue&type=style&index=0&id=ed48ae80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed48ae80",
  null
  
)

export default component.exports